export const australiaStates = [
  "NSW",
  "VIC",
  "QLD",
  "SA",
  "NT",
  "WA",
  "TAS",
  "ACT",
];

export const nZstates: string[] = [
  "AUCKLAND",
  "BLENHEIM",
  "BLUFF",
  "CHRISTCHURCH",
  "DUNEDIN",
  "GREYMOUTH",
  "HAMILTON",
  "KERI KERI",
  "NAPIER",
  "NELSON",
  "PALMERSTON NORTH",
  "QUEENSTOWN",
  "ROTARUA",
  "TAURANGA",
  "WELLINGTON",
  "WHANGAREI",
];
